<template>
  <v-container fluid>

    <v-alert type="error" v-model="showError">{{error}}</v-alert>

    <v-data-table :headers="headers" :items="users">
      <template v:slot="items" slot-scope="props">
        <td>{{ props.item.sub }}</td>
        <td class="text-xs-right">{{ props.item.email }}</td>
        <td class="text-xs-right">
          <v-checkbox v-model="props.item.email_verified" disabled>
        </v-checkbox></td>
        <td class="text-xs-right">
          <v-checkbox v-model="props.item.enabled" disabled></v-checkbox>
        </td>
        <td class="text-xs-right">{{ props.item.status}}</td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  export default {

    data() {
      return {
        error: '',
        users: [],
        headers: [
          { text: "ID", value: 'sub'},
          { text: "E-Mail", value: 'email'},
          { text: "E-Mail verifiziert", value: 'email_verified'},
          { text: "Aktiviert", value: 'enabled'},
          { text: "Status", value: 'status'},
        ]
      }
    },

    computed: {
      showError() {
        return this.error.length > 0;
      }
    },

    mounted() {
      this.fetchUsers();
    },

    methods: {
      fetchUsers() {
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();

        const params = {
          UserPoolId: 'eu-central-1_Dnd3ZZlkU',
//              AttributesToGet: [
//                'STRING_VALUE',
//                /!* more items *!/
//              ],
//              Filter: 'STRING_VALUE',
//              Limit: 0,
//              PaginationToken: 'STRING_VALUE'
        };

        function getUserAttributes(attributesArr) {
          const attrs = {};
          attributesArr.forEach(attr => {
            attrs[attr.Name] = attr.Value;
          });
          return attrs;
        }

        cognitoidentityserviceprovider.listUsers(params, (err, data) => {
          if(err) {
            console.error('ERR', err.message);
            this.error = err.message;
            return false;
          }

          this.error = "";

          const users = data.Users.map( item => ({
            ...getUserAttributes(item.Attributes),
            enabled: item.Enabled,
            status: item.UserStatus,
            user_id: item.Username
          }));

          this.users = users;
        });
      }
    }

  }
</script>



// WEBPACK FOOTER //
// Users.vue?6fb48292